import { TIMER } from '../types.js';

const initialState = new Date();

export default function reducerState (state = initialState, action) {
  switch(action.type) {
    case TIMER :
      return new Date();
    default:
      return state;
  }
}
